import { checkIfProgramCurrentlyRuns } from '@/shared/classes/epg/helpers/isProgramRunning'
import {
    getFormattedProgramDuration,
    getProgramDurationProgress,
} from '@/shared/classes/epg/helpers/programDurationHelpers'
import Program from '@/shared/classes/epg/program/program'

export const getCurrentProgram = (fullyNamesPrograms: Program[]) => {
    let currentProgram: Program | undefined
    let programDurationProgress = 0
    let programFormattedDuration = ''

    if (fullyNamesPrograms.length !== 0) {
        fullyNamesPrograms.forEach((fullyNamedProgram: Program) => {
            const { startMilis, endMilis, durationMilis } = fullyNamedProgram

            if (checkIfProgramCurrentlyRuns(startMilis, endMilis) === 0) {
                currentProgram = fullyNamedProgram
                programDurationProgress = Math.floor(
                    getProgramDurationProgress(startMilis, durationMilis)
                )
                programFormattedDuration = getFormattedProgramDuration(
                    startMilis,
                    endMilis
                )
            }
        })
    }
    return {
        currentProgram,
        programDurationProgress,
        programFormattedDuration,
    }
}
